import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import Select from 'react-select';

class RolesEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      id: null,
      name: null,
      english_name: null,
      initials: null,
      order: null,
      schedule_uses: null,
      calculate_holidays: null,
      mechanic: null,
      designation: null,
      stamp: null,
      sigtrip_id: null,
      sigtrip_roles: [],
      role_certifications: [],
      stamps: [],
      options_default: [
        {value: 0, label: 'Não'},
        {value: 1, label: 'Sim'}
      ],
     };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.addCertifications = this.addCertifications.bind(this);
    this.ativarCertification = this.ativarCertification.bind(this);
    this.desativarCertification = this.desativarCertification.bind(this);

    this.loadData = this.loadData.bind(this);
    this.edit = this.edit.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/funcao/info/edicao/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.main.id,
            name: responseJson.data.main.name,
            english_name: responseJson.data.main.english_name,
            initials: responseJson.data.main.initials,
            order: responseJson.data.main.order,
            schedule_uses: responseJson.data.main.schedule_uses,
            calculate_holidays: responseJson.data.main.calculate_holidays,
            mechanic: responseJson.data.main.mechanic,
            designation: responseJson.data.main.designation,
            stamp: responseJson.data.main.stamp,
            sigtrip_id: responseJson.data.main.sigtrip_id,
            stamps: responseJson.data.stamps,
            sigtrip_roles: responseJson.data.sigtrip_roles,
            role_certifications: responseJson.data.role_certifications,
            certifications_list: responseJson.data.certifications_list,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
     });
    });
  }


  edit(event) {
    event.preventDefault();
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      english_name: this.state.english_name,
      initials: this.state.initials,
      order: this.state.order,
      schedule_uses: this.state.schedule_uses,
      calculate_holidays: this.state.calculate_holidays,
      mechanic: this.state.mechanic,
      designation: this.state.designation,
      stamp: this.state.stamp,
      sigtrip_id: this.state.sigtrip_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  addCertifications(event) {
    event.preventDefault();
    var datasave = {
      certification_id: this.state.certification_id,
      role_id: this.state.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcao/certificado', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({ role_certifications: responseJson.data });
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Fetch ativando um item
  ativarCertification(event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de ativar esse certificado?');
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/funcao/certificado/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ role_certifications: responseJson.data });
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Fetch deletando um item
  desativarCertification(event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de desativar esse certificado?');
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/funcao/certificado/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ role_certifications: responseJson.data });
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }




  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-fluid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Editar função</h3>
      <Link to="/funcoes" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Nome:</label>
            <input type="text" className="form-control" name="name" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Nome Inglês:</label>
            <input type="text" className="form-control" name="english_name" value={this.state.english_name} onChange={this.handleChange.bind(this, 'english_name')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Sigla:</label>
            <input type="text" className="form-control" name="initials" value={this.state.initials} onChange={this.handleChange.bind(this, 'initials')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Requer designação?</label>
            <Select
              className="form-field-name"
              name="designation"
              value={this.state.designation}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'designation')}
              options={this.state.options_default}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Ordem:</label>
            <input type="text" className="form-control" name="order" value={this.state.order} onChange={this.handleChange.bind(this, 'order')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Carimbo:</label>
            <Select
              className="form-field-name"
              name="stamp"
              value={this.state.stamp}
              searchable={true}
              placeholder={'Selecionar carimbo'}
              onChange={this.handleSelectChange.bind(this, 'stamp')}
              options={this.state.stamps}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Usada em escala?</label>
            <Select
              className="form-field-name"
              name="schedule_uses"
              value={this.state.schedule_uses}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'schedule_uses')}
              options={this.state.options_default}
            />
          </div>
          <div className="col-md-6 form-group">
            <label>Calcula férias?</label>
            <Select
              className="form-field-name"
              name="calculate_holidays"
              value={this.state.calculate_holidays}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'calculate_holidays')}
              options={this.state.options_default}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Do tipo mecânico?</label>
            <Select
              className="form-field-name"
              name="mechanic"
              value={this.state.mechanic}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'mechanic')}
              options={this.state.options_default}
            />
          </div>
          <div className="col-md-6 form-group">
            <label>Equivalência no SIGTRIP:</label>
            <Select
              className="form-field-name"
              name="sigtrip_id"
              value={this.state.sigtrip_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'sigtrip_id')}
              options={this.state.sigtrip_roles}
            />
          </div>
        </div>
        <hr/>
        <button type={'submit'} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Editar função</button>
      </form>
      <hr/>
      <div className="row">
        <div className="col-md-6">
          <h4 className="page-title">Adicionar certificados</h4>
          <hr/>
          <form onSubmit={this.addCertifications}>
            <div className="row">
              <div className="col-md-6 form-group">
                <label>Certificado:</label>
                <Select
                  className=""
                  name="certification_id"
                  value={this.state.certification_id}
                  searchable={true}
                  placeholder={'Selecionar gestores'}
                  onChange={this.handleSelectChange.bind(this, 'certification_id')}
                  options={this.state.certifications_list}
                />
              </div>
            </div>
            <button type={'submit'} className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> Adicionar certificados</button>
          </form>
        </div>
        <div className="col-md-6">
          <h4 className="page-title">Certificados</h4>
          <hr/>
          <table className="table table-hover tabled-striped table-bordered">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Ativo?</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(self.state.role_certifications).map(function(k) {
                return (
                  <tr>
                    <td className="col-md-5">{self.state.role_certifications[k].name}</td>
                    <td className="text-center">{(self.state.role_certifications[k].active === 1) ?  <span className="label label-success">ativo</span> : <span className="label label-danger">inativo</span>}</td>
                    <td className="text-center">
                      {(self.state.role_certifications[k].active === 1) ?
                        <button className="btn btn-sm btn-danger" value={self.state.role_certifications[k].id} onClick={self.desativarCertification}><i className="fa fa-fw fa-power-off"></i></button>
                        :
                        <button className="btn btn-sm btn-success" value={self.state.role_certifications[k].id} onClick={self.ativarCertification}><i className="fa fa-fw fa-power-off"></i></button>
                      }
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
    );
  }
}

export default RolesEdit;



// WEBPACK FOOTER //
// ./src/Components/Roles/RolesEdit.js